var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock_ico",
    "data-name": "lock ico",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.612,
    height: 82.612,
    viewBox: "0 0 82.612 82.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M66.713,73.027l-5.188-5.188a29.756,29.756,0,0,0,3.811-14.347v-.548h2.754V50.19H65.336V37.8a1.376,1.376,0,0,0-1.377-1.377H54.321V28.16a1.376,1.376,0,0,0-1.377-1.377H48.813V22.653a20.653,20.653,0,0,0-41.306,0v4.131H3.377A1.376,1.376,0,0,0,2,28.16V69.466a6.892,6.892,0,0,0,6.884,6.884h22.67a47.35,47.35,0,0,0,11.1,8.1,1.373,1.373,0,0,0,1.3,0A43.724,43.724,0,0,0,60.061,70.268l4.7,4.706H59.828v2.754h8.261a1.377,1.377,0,0,0,1.377-1.377V68.089H66.713ZM62.582,53.492A26.834,26.834,0,0,1,59.5,65.808l-2.4-2.4a30.376,30.376,0,0,0,2.659-10.467h2.827Zm-5.507-3.3H43.306a1.376,1.376,0,0,0-.973,2.35L53.754,63.962a27.649,27.649,0,0,1-10.448,10.81A27.667,27.667,0,0,1,29.537,50.839V44.683H57.075ZM46.63,52.944H56.988a27.649,27.649,0,0,1-1.977,8.38ZM10.261,22.653a17.9,17.9,0,0,1,35.8,0v4.131H41.929V22.653a13.769,13.769,0,0,0-27.537,0v4.131H10.261Zm28.914,4.131H17.146V22.653a11.015,11.015,0,1,1,22.03,0ZM4.754,52.944h8.261v4.131H4.754Zm8.261-2.754H4.754V46.06h8.261ZM4.754,59.828h8.261v4.131H4.754Zm8.261-16.522H4.754V39.175h8.261ZM8.884,73.6a4.136,4.136,0,0,1-4.131-4.131V66.713h9.638a1.376,1.376,0,0,0,1.377-1.377V37.8a1.376,1.376,0,0,0-1.377-1.377H4.754V29.537H51.567v6.884H22.653A1.376,1.376,0,0,0,21.276,37.8V53.492a31.343,31.343,0,0,0,7.76,20.1Zm34.422,8.071C31.221,74.993,24.03,64.506,24.03,53.492V39.175H62.582V50.19H59.828V43.306a1.376,1.376,0,0,0-1.377-1.377H28.16a1.376,1.376,0,0,0-1.377,1.377v7.531A30.424,30.424,0,0,0,42.646,77.56a1.379,1.379,0,0,0,1.319,0A30.4,30.4,0,0,0,55.78,65.988l2.288,2.288A40.413,40.413,0,0,1,43.306,81.668Z",
    transform: "translate(-2 -2)",
    fill: "#3acce1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 2.485,
    height: 2.981,
    transform: "translate(69.133 48.263)",
    fill: "#3acce1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 2.485,
    height: 2.981,
    transform: "translate(74.599 48.263)",
    fill: "#3acce1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 2.981,
    height: 2.981,
    transform: "translate(79.568 48.263)",
    fill: "#e72369"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 2.485,
    height: 2.485,
    transform: "translate(74.599 10.994)",
    fill: "#e72369"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 2.981,
    height: 2.485,
    transform: "translate(79.568 10.994)",
    fill: "#3acce1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M65.653,21.4H49.7l3.157-3.157-1.947-1.947L45.4,21.8a1.375,1.375,0,0,0,0,1.947l5.507,5.507,1.947-1.947L49.7,24.151H65.653Z",
    transform: "translate(14.205 3.387)",
    fill: "#3acce1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M57.858,27.24l-1.947-1.947L50.4,30.8a1.375,1.375,0,0,0,0,1.947l5.507,5.507,1.947-1.947L54.7,33.151H66.522V30.4H54.7Z",
    transform: "translate(16.089 6.778)",
    fill: "#3acce1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M44.911,19.255l1.947-1.947L43.7,14.151H59.653V11.4H43.7L46.858,8.24,44.911,6.293,39.4,11.8a1.375,1.375,0,0,0,0,1.947Z",
    transform: "translate(11.944 -0.382)",
    fill: "#3acce1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.8b176d1569e895a4387cd96e6d9b5a17.svg";
export { ForwardRef as ReactComponent };